'use client';

import { createContext, useContext } from 'react';

interface MenuItemContextValue {
  readonly isDisabled: boolean;
}

const MenuItemContext = createContext<MenuItemContextValue | null>(null);

MenuItemContext.displayName = 'MenuItemContext';

function useMenuItemContext() {
  return useContext(MenuItemContext);
}

export { MenuItemContext, useMenuItemContext };
